
const productTop = document.getElementById('product-top') ? document.getElementById('product-top') : document.getElementById('gift-coin-top');
const productId = productTop.getAttribute('data-product-id');
const firstVariantId = $('#product-top').attr('data-first-variant-id');
var selectionVariantId = $('#product-top').attr('data-selected-variant-id');
var customisationProperties = {};
var imageResLoaded = false;
